import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiCode, FiTrendingUp, FiGlobe, FiDatabase, FiSmartphone, FiBarChart } from 'react-icons/fi';
import './Streams.css'; // Import the CSS file

const Streams = () => {
  const [activeTab, setActiveTab] = useState('tech');

  const techDomains = [
    { icon: <FiGlobe />, name: 'Web Development', color: '#000000' },
    { icon: <FiSmartphone />, name: 'App Development', color: '#1a1a1a' },
    { icon: <FiCode />, name: 'Backend Development', color: '#2d2d2d' },
    { icon: <FiCode />, name: 'API Development', color: '#000000' },
    { icon: <FiBarChart />, name: 'Data Analysis', color: '#2d2d2d' },
    { icon: <FiCode />, name: 'AI Automation', color: '#1a1a1a' },
    { icon: <FiGlobe />, name: 'Digital Marketing', color: '#2d2d2d' }
  ];

  const nonTechDomains = [
    'Soft Skills & Communication',
    'Professional Presentations',
    'MS Office & Productivity Tools',
    'Accounting Fundamentals',
    'Data Analysis Basics',
    'Digital Marketing Essentials',
    'Sales & Business Development',
    'Photo & Video Editing',
    'Content Writing & Copywriting',
    'Research Writing',
    'Film Making & Production'
  ];

  const techStreams = ['CS', 'IT', 'DSDA'];
  const nonTechStreams = ['BA', 'BCOM', 'BFM', 'BMMC'];

  return (
    <section id="streams" className="streams-section section-padding">
      <div className="streams-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="streams-header"
        >
          <h2 className="section-title">Choose Your Stream</h2>
          <p className="section-subtitle">
            We provide comprehensive training for both Tech and Non-Tech streams
          </p>
        </motion.div>

        <div className="tabs-container">
          <div className="tabs">
            <button
              onClick={() => setActiveTab('tech')}
              className={`tab ${activeTab === 'tech' ? 'active-tab' : ''}`}
            >
              <FiCode className="tab-icon" />
              Tech Streams
            </button>
            <button
              onClick={() => setActiveTab('non-tech')}
              className={`tab ${activeTab === 'non-tech' ? 'active-tab' : ''}`}
            >
              <FiTrendingUp className="tab-icon" />
              Non-Tech Streams
            </button>
          </div>

          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="tab-content"
          >
            {activeTab === 'tech' ? (
              <>
                <div className="streams-list">
                  <h3 className="streams-title">Eligible Streams (Tech)</h3>
                  <div className="streams-grid">
                    {techStreams.map((stream) => (
                      <div key={stream} className="stream-badge">
                        {stream}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="domains-section">
                  <h3 className="domains-title">Available Domains</h3>
                  <p className="domains-subtitle">
                    Choose your specialization area for training
                  </p>
                  <div className="domains-grid">
                    {techDomains.map((domain) => (
                      <div
                        key={domain.name}
                        className="domain-card"
                        style={{ '--domain-color': domain.color }} // Dynamic color
                      >
                        <div className="domain-icon">
                          {React.cloneElement(domain.icon, {
                            size: 24,
                            color: '#ffffff'
                          })}
                        </div>
                        <span className="domain-name">{domain.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="streams-list">
                  <h3 className="streams-title">Eligible Streams (Non-Tech)</h3>
                  <div className="streams-grid">
                    {nonTechStreams.map((stream) => (
                      <div key={stream} className="stream-badge">
                        {stream}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="domains-section">
                  <h3 className="domains-title">Training Coverage</h3>
                  <p className="domains-subtitle">
                    Comprehensive non-tech skills development
                  </p>
                  <div className="non-tech-list">
                    {nonTechDomains.map((domain, index) => (
                      <div key={domain} className="non-tech-item">
                        <div className="non-tech-number">{index + 1}</div>
                        <span className="non-tech-text">{domain}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="note"
        >
          <div className="note-card">
            <h4 className="note-title">Important Note</h4>
            <p className="note-text">
              <strong>Tech Students:</strong> Choose your preferred domain during enrollment<br />
              <strong>Non-Tech Students:</strong> Get comprehensive training in all listed areas
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Streams;